import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export default function DirectLogin() {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const err = params.get("error");

    if (err === "unauthorized_email") {
      // instead of toast, send them to the page
      window.location.replace("/access-denied?reason=unauthorized_email");
      return;
    }

    if (err) {
      toast.error("Microsoft login failed. Please try again.");
      const url = new URL(window.location.href);
      url.searchParams.delete("error");
      window.history.replaceState({}, "", url);
    }
  }, []);

  return <div>Redirecting to Microsoft…</div>;
}
